  <template>
    <div class="p-6">
      <h1 class="text-3xl font-bold text-gray-900 dark:text-gray-50 mb-6 flex items-center">
        <button
          @click="$router.push('/config')"
          class="mr-4 bg-blue-600 text-white px-4 py-1.5 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition duration-200 text-sm font-medium flex items-center"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-4 w-4 mr-1"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fill-rule="evenodd"
              d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z"
              clip-rule="evenodd"
            />
          </svg>
          Back to Configuration Preview
        </button>
        Approve Agent
      </h1>

      

      <form v-if="showAgent" @submit.prevent="saveAgent" class="space-y-6 bg-white dark:bg-gray-800 dark:text-bg-gray dark:border-gray-800 p-6 rounded-lg shadow-sm border border-gray-200">
        <h1 class="text-2xl font-bold text-gray-900 dark:text-gray-50 mb-6">{{ agent.licensekey}}</h1>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            
          <div>
              <label
                for="license_state"
                class="block text-sm font-medium text-gray-700 dark:text-white"
                >License State</label
              >
              <GlassSelect
                id="organization"
                v-model="agent.license_state"
                :options="license_states"
                placeholder="Select a License State"
                :disabled="true"
                :error="!!fieldErrors['license_state']"
              />
              <FieldError :message="fieldErrors['license_state']"/>
            </div>

            <div>
              <label
                for="operating_system"
                class="block text-sm font-medium text-gray-700 dark:text-white"
                >Operating System</label
              >
              <GlassSelect
                id="operating_system"
                v-model="agent.operating_system"
                :options="configOptions"
                placeholder="Select a License State"
                :disabled="true"
                :error="!!fieldErrors['operating_system']"
              />
              <FieldError :message="fieldErrors['operating_system']"/>
            </div>

          <div>
            <label
              for="organization"
              class="block text-sm font-medium text-gray-700 dark:text-white"
              >Organisation</label
            >
            <GlassSelect
              id="organization"
              v-model="agent.organization"
              :options="orgs"
              placeholder="Select an Organization"
              :disabled="true"
              :error="!!fieldErrors['organization']"
            />
            <FieldError :message="fieldErrors['organization']"/>
          </div>

          <div v-if="configAssociation === 'Group'">
            <label
              for="group"
              class="block text-sm font-medium text-gray-700 dark:text-white"
              >Agent Group</label
            >
            <GlassSelect
              id="group"
              v-model="agent.group"
              :options="agent_groups"
              placeholder="Select an Agent Group"
              :disabled="true"
              :error="!!fieldErrors['group']"
            />
            <FieldError :message="fieldErrors['group']"/>
            <FieldError :message="fieldErrors['non_field_errors']"/>
          </div>

          <div v-if="agent.hostname">
            <label
              for="hostname"
              class="block text-sm font-medium text-gray-700 dark:text-white"
              >Hostname</label
            >
            <input
              type="text"
              id="hostname"
              v-model="agent.hostname"
              disabled
              :class="[ 'w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2', fieldErrors['hostname']
                    ? 'ring-2 ring-red-500  focus:ring-red-500'
                    : 'focus:ring-blue-500'
              ]"
            />
            <FieldError :message="fieldErrors['hostname']"/>
          </div>

            <div v-if="agent.username">
              <label
                for="username"
                class="block text-sm font-medium text-gray-700 dark:text-white"
                >Username</label
              >
              <input
                type="text"
                id="username"
                v-model="agent.username"
                disabled
                :class="[ 'w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2', fieldErrors['username']
                      ? 'ring-2 ring-red-500  focus:ring-red-500'
                      : 'focus:ring-blue-500'
                ]"
              />
              <FieldError :message="fieldErrors['username']"/>
            </div>
          </div>
    
          <div class="flex justify-end space-x-3">
            
            <button
              type="submit"
              class="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              Approve
            </button>
          </div>
      </form>
    </div>
  </template>

  <script>

  import { createAgent, getAgents, updateAgent } from "@/services/agentService";
  import { getProducts , createProduct} from "@/services/productsService";
  import { getOrgs } from "@/services/wsOrgService";
  import { getAgentGroups } from "@/services/agentGroupService";
  import { useStore } from "@/store";
  import FieldError from "@/components/FieldError.vue";
  import ConfigWorkSpaceDetails from "./ConfigWorkSpaceDetails.vue";
  import { getBinarys } from "@/services/binaryService";
  import { getConfigs } from "@/services/configService";
  import { ArrowTopRightOnSquareIcon } from "@heroicons/vue/24/outline";
  import GlassSelect from "@/components/GlassSelect.vue";

  export default {
    name: "OrganizationDetails",
    components: {
      FieldError,
      ConfigWorkSpaceDetails,
      GlassSelect
    },
    props: {
      licensekeyParent:{
        type: String,
      },
    },
    data() {
      return {
        multiformComplete: false,
        progress: null,
        configAssociation: null,
        multistepAgent: null,
        generatingBinary: false,
        configtypes: ["Organization", " Group", "Agent"],
        chooseConfigType: false,
        showAgent: true,
        showWorkspace: false,
        showCollector: false,
        agent: {
          hostname: "",
          organization: null,
          hostname: "",
          license_state: "Unapproved",
          username: "",
          licensekey: "",
          operating_system: "",
          group: null,
          id: null
        },
        product: {
          name: "MivuInstaller",
          link: "",
          organization: "",
          agent: "",
        },
        loading: false,
        error: null,
        fieldErrors: {},
        isNewAgent: false,
        orgs: [],
        agent_groups: [],
        selectedConfig: "",
        selectedOrg: "",
        license_states : ['Active', 'Unapproved', 'Pending', 'HardStop'],
        configSelection: true,
        configOptions: [
          "Windows",
          "Linux",
          "Mac" ], 
      };
    },
    computed: {
      user() {
        return useStore.getUser();
      }, 
      formattedAgent() {
        return {
          ...this.agent
        };
      },
    },
    async created() {
      const agentId = this.licensekeyParent;
      await this.fetchAgent(agentId);
      await this.fetchOrg();
      await this.fetchGroups();
    },
    methods: {
      async fetchGroups(){
        try {
          this.agent_groups = await getAgentGroups();
        } catch (error) {
          console.error("Error fetching groups:", error);
        }
      },
      async fetchOrg(){
        try {
          this.orgs = await getOrgs();
        } catch (error) {
          console.error("Error fetching organization:", error);
        }
      },
      async fetchProducts(agentID){
        try {
          const products = await getProducts();
          this.product = products.find((item) => item.agent == agentID);

        } catch (error) {
          console.error("Error fetching organization:", error);
        }
      },
      async fetchAgent(agentId) {
        this.loading = true;
        this.error = null;
        try {
            const agents = await getAgents();
            this.agent = agents.find(item => item.licensekey == agentId)
        } catch (error) {
          console.error("Error fetching agent:", error);
          this.error =
            "An error occurred while fetching agent details. Please try again later.";
        } finally {
          this.loading = false;
        }
      },
      async saveAgent() {
        this.loading = true;
        this.error = null;
        
        try {

        const agentData = {...this.agent, license_state: "Active"}
        await updateAgent(this.agent.licensekey, agentData);
        this.$router.push({ name: "ConfigView" });

        } catch (error) {
          console.error("Error saving organization:", error);
        } finally {
          this.loading = false;
        }
      },
      
    },
  };
  </script>
